export default __webpack_public_path__ + "static/hero-71eb2274a99e4933407d4d0f263c7166.svg";